import { CONTACTS_FOURNISSEUR_PAR_DEFAUT, RELANCE_FOURNISSEUR_PAR_DEFAUT, RELANCE_TRACKING_PAR_DEFAUT, } from './relances.js';
import { RESOLUTION_LITIGE_PAR_DEFAUT } from './types.js';
/**
 * Valeurs posées au seed. Elles vivent ensuite en base et se modifient depuis
 * la page Réglages — le moteur ne lit jamais cette constante, il reçoit les
 * réglages en paramètre.
 *
 * Plusieurs de ces seuils sont des arbitrages métier repris du prototype, pas
 * des vérités techniques : délais de transit et tolérance de livraison sont à
 * revoir avec les chiffres réels des transporteurs.
 */
export const REGLAGES_PAR_DEFAUT = {
    seuils: {
        envoiCritique: 3,
        envoiBloquant: 15,
        relanceFournisseur: 5,
        enlevementDelai: 2,
        trackingRetard: 1,
        trackingBloquant: 7,
        toleranceLivraison: 1,
        suiviMuet: 3,
        avisDelai: 3,
        avisJusqua: 14,
    },
    /**
     * Délais de transit, en jours. Purement indicatifs depuis que l'estimation
     * interne ne déclenche plus d'alerte : ils n'alimentent que la ligne
     * « livraison estimée » de la fiche, et se corrigent depuis Réglages.
     */
    transit: {
        Dachser: 4,
        DSV: 5,
        DHL: 5,
        FedEx: 5,
        DPD: 5,
        // Groupage routier européen, comme Dachser et DSV : même ordre de grandeur,
        // à confirmer sur les premiers envois réels.
        Rhenus: 5,
        // Réseau français en bi-quotidien : 2 jours est l'ordre de grandeur, à
        // confirmer sur les premiers envois réels.
        'France Express': 2,
        Autre: 5,
    },
    transitParDefaut: 5,
    contactsTransporteur: {
        Dachser: '',
        DSV: '',
        DHL: '',
        FedEx: '',
        DPD: '',
        Rhenus: '',
        'France Express': '',
        Autre: '',
    },
    // Adressé au FOURNISSEUR, pas au transporteur : les transporteurs que Mosaik
    // croise n'ont pas de service litige, et le contrat de transport est celui du
    // fournisseur — c'est lui le donneur d'ordre, et le seul à pouvoir faire
    // bouger son transporteur.
    objetRelance: 'Livraison bloquée — commande {{ref}} / suivi {{tracking}}',
    corpsRelance: [
        'Bonjour,',
        '',
        "Votre expédition de notre commande {{ref}}, partie le {{expedition}} par {{transporteur}},",
        "n'est toujours pas livrée à ce jour.",
        '',
        'Numéro de suivi : {{tracking}}',
        'Destinataire : {{client}}, {{ville}}',
        'Livraison estimée : {{prevue}} (retard constaté : {{retard}} jours)',
        'Dernier statut remonté : {{statut}}',
        '',
        'Pouvez-vous intervenir auprès de {{transporteur}} pour obtenir la position exacte du colis',
        'et une date de livraison ferme ?',
        "En cas d'avarie ou de perte, merci de nous transmettre le constat correspondant.",
        '',
        'Cordialement,',
    ].join('\n'),
    resolutionLitige: { ...RESOLUTION_LITIGE_PAR_DEFAUT },
    contactsFournisseur: { ...CONTACTS_FOURNISSEUR_PAR_DEFAUT },
    relanceFournisseur: {
        fr: { ...RELANCE_FOURNISSEUR_PAR_DEFAUT.fr },
        en: { ...RELANCE_FOURNISSEUR_PAR_DEFAUT.en },
    },
    relanceTracking: {
        fr: { ...RELANCE_TRACKING_PAR_DEFAUT.fr },
        en: { ...RELANCE_TRACKING_PAR_DEFAUT.en },
    },
};
/*
 * `contactTransporteur` a été retiré : plus rien ne le lisait.
 *
 * Les transporteurs n'ont pas de service litige — le contrat de transport est
 * celui du fournisseur, et c'est à lui qu'on écrit (cf.
 * `destinatairesRelanceTransporteur`). La table `contactsTransporteur` reste
 * dans les réglages pour ne pas migrer la base, mais son accesseur n'avait plus
 * d'appelant : un export mort se met tôt ou tard à servir par erreur.
 */
/** Délai de transit d'un transporteur, avec repli sur le défaut configuré. */
export function delaiTransit(reglages, transporteur) {
    if (!transporteur)
        return reglages.transitParDefaut;
    const d = reglages.transit[transporteur];
    return typeof d === 'number' ? d : reglages.transitParDefaut;
}
//# sourceMappingURL=reglages.js.map